import { IsNotEmpty, IsOptional, IsUUID, IsString } from 'class-validator';
import { PerformanceCategory } from '../../enums';

export class GetUserPerformanceDto {
	@IsUUID()
	@IsNotEmpty()
	lobbyId: string;

	@IsUUID()
	@IsOptional()
	userBotId?: string;
}

export class MomentMarketDto {
	question: string;
	matchName: string | null;
	userProb: number;
	crowdProb: number;
	outcome: number;
	rbp: number;
}

export class MomentMatchDto {
	matchId: string;
	matchName: string;
	forecasts: number;
	totalRbp: number;
	homeCompetitors?: unknown;
	awayCompetitors?: unknown;
}

export class PerformanceSummaryDto {
	averageRbpGapToCrowd: number;
	contrarianWinRate: number | null;
	forecastsSettled: number;
	confidenceBias: number;
	percentileRank: number | null;
}

export class PerformanceHighlightsDto {
	bestMarket: MomentMarketDto | null;
	worstMarket: MomentMarketDto | null;
	bestMatch: MomentMatchDto | null;
	worstMatch: MomentMatchDto | null;
}

export class MatchPerformanceDto {
	matchId: string;
	matchName: string;
	totalRbp: number;
	homeCompetitors?: unknown;
	awayCompetitors?: unknown;
	seasonType: string | null;
	forecasts: number;
	forecastsBeatCrowd: number;
}

export class MatchPerformanceSectionDto {
	top: MatchPerformanceDto[];
	bottom: MatchPerformanceDto[];
}

export class CalibrationBinDto {
	bin: string;
	lo: number;
	hi: number;
	n: number;
	hitRate: number | null;
	avgPredicted: number | null;
}

export class PerformanceCategoryStatsDto {
	category: PerformanceCategory;
	forecasts: number;
	averageRbpGapToCrowd: number | null;
	winRate: number | null;
}

export class TopCategoryDto {
	name: string;
	forecasts: number;
	averageRbpGapToCrowd: number;
	contrarianWinRate: number | null;
	contrarianWins: number;
	contrarianTotal: number;
	confidenceBias: number;
	confidenceBiasLevel: 'TIMID' | 'OPTIMAL' | 'AGGRESSIVE';
}

export class UserPerformanceResponseDto {
	summary: PerformanceSummaryDto;
	highlights: PerformanceHighlightsDto;
	calibrationBins: CalibrationBinDto[];
	calibrationForecastsRemaining: number;
	matches: MatchPerformanceSectionDto;
	categories: PerformanceCategoryStatsDto[];
	topCategories: TopCategoryDto[];
}

export class GetUserPredictedMarketsDto {
	@IsUUID()
	@IsOptional()
	userId?: string;

	@IsUUID()
	@IsNotEmpty()
	lobbyId: string;

	@IsString()
	@IsNotEmpty()
	category: string;

	@IsString()
	@IsOptional()
	search?: string;
}

export class PredictedMarketItemDto {
	marketId: string;
	matchId: string | null;
	question: string;
	probability: number;
	crowd: number;
	rbpGap: number;
	brierScore: number | null;
	createdDate: Date;
	homeCompetitors: unknown;
	awayCompetitors: unknown;
	ext_api_market: string | null;
	matchName: string | null;
}

export class OverallStatsDto {
	totalForecasts: number;
	totalRbpGap: number;
	timesBeatenCrowd: number;
}

export interface UserPredictedMarketsBySubCategoryDto {
	markets: Record<string, PredictedMarketItemDto[]>;
}
